import { render, staticRenderFns } from "./ProviderBlurb.vue?vue&type=template&id=98d14dbe&scoped=true&"
import script from "./ProviderBlurb.vue?vue&type=script&lang=ts&"
export * from "./ProviderBlurb.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderBlurb.vue?vue&type=style&index=0&id=98d14dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d14dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow,VThemeProvider})
